import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { entitiesActions } from '@/store/entities';
import { message } from 'antd';

export const Toast = () => {
  const [messageApi, contextHolder] = message.useMessage();

  const dispatch = useDispatch();
  const { toastInfo, toastError, toastSuccess } = useSelector((state) => state.entities);

  const success = () => {
    messageApi.success(toastSuccess);
  };

  const info = () => {
    messageApi.info(toastInfo);
  };

  const error = () => {
    messageApi.error(toastError);
  };

  useEffect(() => {
    if (toastSuccess) {
      try {
        success();
        setTimeout(() => {
          dispatch(entitiesActions.hideToastSuccess());
        }, 2000);
      } catch (e) {
        console.error(e);
      }
    }
  }, [toastSuccess]);

  useEffect(() => {
    if (toastInfo) {
      try {
        info();
        setTimeout(() => {
          dispatch(entitiesActions.hideToastInfo());
        }, 2000);
      } catch (e) {
        console.error(e);
      }
    }
  }, [toastInfo]);

  useEffect(() => {
    if (toastError) {
      try {
        error();
        setTimeout(() => {
          dispatch(entitiesActions.hideToastError());
        }, 2000);
      } catch (e) {
        console.error(e);
      }
    }
  }, [toastError]);

  return <>{contextHolder}</>;
};
